import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=952fa90e&scoped=true&"
import script from "./Layout2.vue?vue&type=script&lang=js&"
export * from "./Layout2.vue?vue&type=script&lang=js&"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=952fa90e&lang=scss&scoped=true&"
import style2 from "./Layout2.vue?vue&type=style&index=2&id=952fa90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952fa90e",
  null
  
)

export default component.exports